import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { apiErr } from "@/lib/format";
import { useModalForm } from "@/lib/modalForm";
import BotonCerrar from "@/components/BotonCerrar";
import { FileTextIcon, PrinterIcon, DownloadSimpleIcon } from "@phosphor-icons/react";

/**
 * Visor del PDF oficial de un documento (factura, nota de débito…) dentro del sistema: imprimir y descargar.
 * Solo consulta: abrirlo o cerrarlo no modifica el documento.
 */
// `body`: el PDF se pide por POST con esos datos (vista previa de un documento aún no emitido)
export default function DocumentoPdfModal({ url, titulo, numero, archivo, onClose, testid = "documento-pdf", body = null }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState("");
  const frame = useRef(null);
  const vm = useModalForm({ onClose });
  useEffect(() => {
    let u = null;
    (body ? api.post(url, body, { responseType: "blob" }) : api.get(url, { responseType: "blob" }))
      .then((res) => { u = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); setSrc(u); })
      .catch((e) => setError(apiErr(e)));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [url]);
  const imprimir = () => {
    try { frame.current?.contentWindow?.focus(); frame.current?.contentWindow?.print(); }
    catch { window.open(src, "_blank"); }
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" {...vm.overlayProps}>
      <div className="bg-card border border-agro-green/40 rounded-lg w-full max-w-4xl h-[92vh] flex flex-col" onClick={(e) => e.stopPropagation()}
        data-testid={testid}>
        <div className="p-4 border-b border-border flex items-center gap-3">
          <FileTextIcon size={22} className="text-agro-green" />
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-wider text-agro-green">{titulo}</div>
            <div className="font-heading font-semibold font-mono truncate" data-testid={`${testid}-numero`}>{numero || "—"}</div>
          </div>
          <button onClick={imprimir} disabled={!src} data-testid={`${testid}-imprimir`}
            className="px-4 py-2 text-xs bg-agro-green hover:bg-agro-green-hover text-black font-semibold rounded-md flex items-center gap-1.5 disabled:opacity-50">
            <PrinterIcon size={14} weight="bold" /> IMPRIMIR
          </button>
          {src && (
            <a href={src} download={archivo || `${numero || "documento"}.pdf`} data-testid={`${testid}-descargar`}
              className="px-3 py-2 text-xs border border-border rounded-md flex items-center gap-1.5 text-text-secondary hover:bg-white/5">
              <DownloadSimpleIcon size={14} /> PDF
            </a>
          )}
          <BotonCerrar onClick={vm.cerrar} />
        </div>
        <div className="flex-1 bg-app">
          {error ? <div className="p-8 text-center text-red-400 text-sm" data-testid={`${testid}-error`}>{error}</div>
            : !src ? <div className="p-8 text-center text-text-muted text-sm">Generando el documento…</div>
              : <iframe ref={frame} src={src} title={`${titulo} ${numero || ""}`} className="w-full h-full" data-testid={`${testid}-iframe`} />}
        </div>
      </div>
    </div>
  );
}
